import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useCreateJobProfile = () => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ input }) => {
      const result = await restClient({
        url: `${prefix}/job-profile`,
        method: 'POST',
        data: input
      });
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['jobProfiles']);
    }
  });
};
